// eslint-disable max-len
export default {
  paymentMethodCard: 'Card',
  paymentMethodPaypal: 'Paypal',
  paymentMethodBankTransfer: 'Bank Transfer',
  paymentMethodOXXO: 'OXXO',
  paymentMethodAffirm: 'Affirm',
  paymentMethodApplePay: 'Apple Pay',
  paymentMethodGooglePay: 'Google Pay',
  firstName: 'First Name',
  lastName: 'Last Name',
  fullName: 'Full Name',
  email: 'Email',
  cardholderName: 'Cardholder Name',
  selectPaymentMethod: 'Select your preferred payment method',
  contactInformation: 'Contact information',
  paymentDetails: 'Payment details',
  cardNumber: 'Card Number',
  cardExpire: 'Expire',
  sameAsAddress: 'Same as address',
  billingAddressDetails: 'Billing Address Details',
  billingStreetAddress: 'Street Address',
  billingStreetAddress2: 'Apt, suite, floor etc.',
  billingCountry: 'Country',
  billingState: 'State',
  billingCity: 'City',
  billingZip: 'ZIP / Postal Code',
  billingEmail: 'Billing Email',
  invalidEmail: 'Invalid email',
  requiredField: 'Required field',
  oxxoMessage:
    'You will be provided payment instructions after confirming the reservation.',
  affirmMessage: 'You will be provided instructions to complete the payment.',
  applePayNotAvailableMessage:
    'Apple Pay is currently unavailable. We apologize for any inconvenience. Please choose any another payment method.',
  googlePayNotAvailableMessage:
    'Google Pay is currently unavailable. We apologize for any inconvenience. Please choose any another payment method.',
  paymentMethodError:
    'Sorry, we could not process your payment. Please choose another payment method.',
  bankTransferMessage:
    'You will be provided transfer instructions after confirming the reservation.',
  unsupportedCardType: 'Unsupported card type.',
  creditCardTypesAccepted: 'Credit Card Types Accepted',
  payPalPaymentCurrency: 'The payment will be processed in {{currency}}',
};
